import { combineReducers } from 'redux'

// ACTIONS
export const FETCH = 'company/candidateDetails/notes/FETCH'
export const FETCH_SUCCESS = 'company/candidateDetails/notes/FETCH_SUCCESS'

export const CREATE = 'company/candidateDetails/notes/CREATE'
export const CREATE_SUCCESS = 'company/candidateDetails/notes/CREATE_SUCCESS'

export const UPDATE_NOTE = 'company/candidateDetails/notes/UPDATE_NOTE'
export const UPDATE_NOTE_SUCCESS = 'company/candidateDetails/notes/UPDATE_NOTE_SUCCESS'

export const DELETE_NOTE = 'company/candidateDetails/notes/DELETE_NOTE'
export const DELETE_NOTE_SUCCESS = 'company/candidateDetails/notes/DELETE_NOTE_SUCCESS'

export const TOGGLE_LOADING = 'company/candidateDetails/notes/TOGGLE_LOADING'
export const TOGGLE_DELETING = 'company/candidateDetails/notes/TOGGLE_DELETING'
export const TOGGLE_UPDATING = 'company/candidateDetails/notes/TOGGLE_UPDATING'

export const RESET = 'company/candidateDetails/notes/RESET'

// ACTION CREATORS
export const toggleLoading = loading => ({
  type: TOGGLE_LOADING,
  payload: { loading },
})

export const toggleDeleting = deleting => ({
  type: TOGGLE_DELETING,
  payload: { deleting },
})

export const toggleUpdating = updating => ({
  type: TOGGLE_UPDATING,
  payload: { updating },
})

export const fetch = (hiring_team_id, candidate_id) => ({
  type: FETCH,
  payload: {
    hiring_team_id,
    params: {
      candidate_id,
      order_by: 'created_at',
      order_direction: 'desc',
      paginate: false,
    },
  },
})

export const fetchSuccess = ({ result }) => ({
  type: FETCH_SUCCESS,
  payload: {
    collection: result,
    lastUpdated: new Date(),
  },
})

export const create = (hiring_team_id, data, formResolve, formReject) => ({
  type: CREATE,
  meta: { hiring_team_id, data, formResolve, formReject },
})

export const createSuccess = ({ result }) => ({
  type: CREATE_SUCCESS,
  payload: { note: result, lastUpdated: new Date() },
})

export const updateNote = (hiring_team_id, note_id, data, formResolve, formReject) => ({
  type: UPDATE_NOTE,
  meta: { formResolve, formReject },
  payload: { hiring_team_id, note_id, data },
})

export const updateNoteSuccess = ({ result }) => ({
  type: UPDATE_NOTE_SUCCESS,
  payload: { note: result, lastUpdated: new Date() },
})

export const deleteNote = (hiring_team_id, note_id) => ({
  type: DELETE_NOTE,
  payload: { hiring_team_id, note_id },
})

export const deleteNoteSuccess = ({ noteId }) => ({
  type: DELETE_NOTE_SUCCESS,
  payload: { id: noteId, lastUpdated: new Date() },
})

export const reset = () => ({
  type: RESET,
})

// REDUCERS
const defaultUtils = {
  loading: true,
  updating: false,
  deleting: false,
  error: null,
  lastUpdated: null,
}

const utils = (state = defaultUtils, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING:
    case TOGGLE_UPDATING:
      return {
        ...state,
        ...payload,
      }

    case FETCH_SUCCESS:
    case CREATE_SUCCESS:
    case DELETE_NOTE_SUCCESS:
    case UPDATE_NOTE_SUCCESS:
      return {
        ...state,
        lastUpdated: payload.lastUpdated,
      }

    case RESET:
      return defaultUtils

    default:
      return state
  }
}

const collection = (state = [], { type, payload }) => {
  switch (type) {
    case FETCH_SUCCESS:
      return [...payload.collection]

    case CREATE_SUCCESS:
      return [payload.note, ...state]

    case UPDATE_NOTE_SUCCESS:
      return state.map(note => (payload.note.id === note.id ? payload.note : note))

    case DELETE_NOTE_SUCCESS:
      return state.map(note => (payload.id === note.id ? { id: payload.id } : note))

    case RESET:
      return []

    default:
      return state
  }
}

export default combineReducers({
  utils,
  collection,
})
